module.exports = __webpack_public_path__ + "assets/5732e12e0d88f98affdc26b75bc5dfbc.svg";